// @flow
import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Proposition from 'common/modules/proposition/domain/proposition';
import PropositionListing from 'common/modules/proposition/domain/propositionListing';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import Advertiser from 'common/modules/advertiser/domain/Advertiser';
import { getCurrentAdvertiser } from 'advertisers/modules/advertiser/selectors/advertiserSelectors';
import { getToken } from 'advertisers/modules/authentication/selectors/sessionSelectors';
import PropositionAPI from '../services/PropositionAPI';

export const ACCEPT_ACTION = 'ACCEPT';
export const DECLINE_ACTION = 'DECLINE';
export type ActionType = 'ACCEPT' | 'DECLINE';

export function propositionHasActions(proposition: Proposition) {
  return proposition && proposition.isProposed();
}

type Props = any & {
  proposition: PropositionListing,
  onChange: (proposition: Proposition) => void,

  advertiser: Advertiser,
  token: string,
  t: any,
};

function withPropositionActions(WrappedComponent) {
  class WithPropositionActions extends Component<Props> {
    async onDeclineProposition() {
      const { actions, t, proposition, onChange, token, advertiser: { reference } } = this.props;

      try {
        const declined = await PropositionAPI.declineProposition(reference, token, proposition.reference);
        onChange(declined);

        actions.openSnackbar('message', t('propositionDeclined'));
      } catch (error) {
        actions.openSnackbar('error', t('propositionDeclinedError'));
      }
    }

    async onAcceptSalesProposition() {
      const { actions, t, proposition, onChange, token, advertiser: { reference } } = this.props;

      try {
        const accepted = await PropositionAPI.acceptProposition(reference, token, proposition.reference);
        onChange(accepted);

        actions.openSnackbar('message', t('propositionAccepted'));
      } catch (error) {
        actions.openSnackbar('error', t('propositionAcceptedError'));
      }
    }

    getActionsOf(): Array<{ label: string, onAction: () => any, type: ActionType }> {
      const { t, proposition } = this.props;
      const actions = [];

      if (proposition.isProposed()) {
        actions.push(
          {
            label: t('accept'),
            type: ACCEPT_ACTION,
            onAction: () => this.onAcceptSalesProposition(),
          },
          {
            label: t('decline'),
            type: DECLINE_ACTION,
            onAction: () => this.onDeclineProposition(),
          },
        );
      }

      return actions;
    }

    render() {
      return (
        <div>
          <WrappedComponent {...this.props} actions={this.getActionsOf()} />
        </div>
      );
    }
  }
  WithPropositionActions.displayName = `WithPropositionActions(${getDisplayName(WrappedComponent)})`;
  return WithPropositionActions;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function mapStateToProps(state) {
  return {
    advertiser: getCurrentAdvertiser(state),
    token: getToken(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({
      openSnackbar,
    }, dispatch),
  };
}

export default compose(translate('proposition'), connect(mapStateToProps, mapDispatchToProps), withPropositionActions);



// WEBPACK FOOTER //
// ./src/advertisers/modules/propositions/decorators/withPropositionActions.js